import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "orange",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M18.108 15 11.442 3.333a1.667 1.667 0 0 0-2.9 0L1.875 15a1.666 1.666 0 0 0 1.458 2.5h13.334a1.667 1.667 0 0 0 1.441-2.5M10 7.5v3.333M10 14.167h.008"
    }, null, -1)
  ]))]))
}
export default { render: render }